export class RuntimeError extends Error {
    localizedMessage;
    constructor(message, options) {
        super(message, options);
        this.name = 'bytereplay.core.RuntimeError';
        this.localizedMessage = options?.localizedMessage ?? message;
    }
}
